import React from "react";
import { BrowserRouter, Routes, Route, Link, NavLink } from "react-router-dom"
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { useLanguage } from '../i18n/translations';

export default function Politika({categories}) {
    const { translate } = useLanguage();
    return (
        <div className="bg-gray-100 text-gray-800">
              <SEO
                title="Politika privatnosti - Bulka Ceramics"
                description=""
                type="website"
                name="Bulka Ceramics"
            />
            <div className="container mx-auto p-6">
                <div class="mb-12 bg-white p-6 rounded-lg shadow">
                    <h1 class="text-2xl font-bold mb-4">{translate("Privacy Policy")}</h1>
                    <p class="mb-2">{translate("Your privacy is very important to us. This privacy policy explains how we collect, use, and protect your personal data.")}</p>
                    <h2 class="text-xl font-semibold mb-2">{translate("Data Collection")}</h2>
                    <p class="mb-2">{translate("We collect information you voluntarily provide when registering on our website or when ordering products. This information includes, but is not limited to: name, address, email address, and phone number.")}</p>
                    <h2 class="text-xl font-semibold mb-2">{translate("Data Usage")}</h2>
                    <p class="mb-2">{translate("We use your data to provide you with quality service, process your orders, and provide you with information about our products and services.")}</p>
                    <h2 class="text-xl font-semibold mb-2">{translate("Data Protection")}</h2>
                    <p class="mb-2">{translate("We take appropriate technical and organizational measures to protect your personal data from unauthorized access, loss, or destruction.")}</p>

                    <h2 class="text-xl font-semibold mb-2">{translate("Cookies and Tracking Technologies")}</h2>
                    <p class="mb-2">{translate("Our website uses cookies and similar tracking technologies to improve your user experience.")}</p>
                    <p class="mb-2">{translate("You can set your cookie preferences in your browser settings. Please note that disabling cookies may affect your ability to use certain features of our website.")}</p>

                    <h2 class="text-xl font-semibold mb-2">{translate("Changes to the Privacy Policy")}</h2>
                    <p class="mb-2">{translate("We reserve the right to change this privacy policy at any time. All changes will be published on this page, and the date of the last modification will be updated. We recommend that you check this page periodically to stay informed of any changes.")}</p>

                    <h2 class="text-xl font-semibold mb-2">{translate("Contact")}</h2>
                    <p>{translate("At any time, you can request a change to your personal data. For any inquiries, contact us at email:")} <a href="mailto:contact@bulkaceramics.com" class="text-blue-500">contact@bulkaceramics.com</a>.</p>
                </div>


            </div>

             <Footer categories={categories} />
        </div>
    )
}